// This file is auto-generated by scripts/generate-version.js
// Do not edit manually

export const VERSION_INFO = {
  version: '3.0.3',
  buildDate: '2026-02-17T17:39:53.391Z',
  commitSha: 'dev'
};
